import Vue from "vue";
import get from "lodash/get";
import { facebookPX } from "./utils/helpers";

const Facebook = {
  enable() {
    Vue.$log.info("fb enable");
    // eslint-disable-next-line no-unused-expressions,wrap-iife
    !(function (f, b, e, v, n) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  },
  wait() {
    return !!window.fbq;
  },
  init() {
    window.fbq("init", "1649877658563488");
  },
  consulta() {
    const pxFace = facebookPX("consulta");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  oferta(context) {
    if (_BBVA_MOTOR === "ofertaPrestamosEmprendedores") {
      const pxFace = facebookPX("oferta");
      if (pxFace.method)
        window.fbq(pxFace.method, pxFace.event, pxFace.content);
      return;
    }
    if (get(context, "state.esCliente", false)) {
      const pxFace = facebookPX("cliente");
      if (pxFace.method)
        window.fbq(pxFace.method, pxFace.event, pxFace.content);
    } else {
      const pxFace = facebookPX("noCliente");
      if (pxFace.method)
        window.fbq(pxFace.method, pxFace.event, pxFace.content);
    }
  },
  compruebaIdentidad() {
    const pxFace = facebookPX("landingQR");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  paso1() {
    const pxFace = facebookPX("paso1");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  paso2() {
    const pxFace = facebookPX("paso2");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  paso3() {
    const pxFace = facebookPX("paso3");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  continuaSucursal() {
    const pxFace = facebookPX("continuaSucursal");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  paso4() {
    const pxFace = facebookPX("paso4");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  solicita() {
    const pxFace = facebookPX("solicita");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  loadingVeridas() {
    const pxFace = facebookPX("loadingVeridas");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  biometriaOK() {
    const pxFace = facebookPX("biometriaOK");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  entrega() {
    const pxFace = facebookPX("entrega");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  resumen() {
    const pxFace = facebookPX("resumen");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  contratos() {
    const pxFace = facebookPX("contratos");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  gracias() {
    const pxFace = facebookPX("gracias");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  usuario() {
    const pxFace = facebookPX("usuario");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  celular() {
    const pxFace = facebookPX("celular");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  final() {
    const pxFace = facebookPX("final");
    if (pxFace.method) window.fbq(pxFace.method, pxFace.event, pxFace.content);
  },
  errorPage(context) {
    const pxFace = facebookPX("mensaje");
    const errorCode = get(context, "mutation.payload", "");
    const erroresRechazo = [
      "RECHAZO_02",
      "RECHAZO_07",
      "RECHAZO_704",
      "calificacionInvalida",
      "rechazoAntecedentes",
      "residenteTemporal",
      "RECHAZO_703",
      "RECHAZO_04",
      "RECHAZO_05",
      "RECHAZO_06",
      "RECHAZO_08",
      "RECHAZO_10",
      "RECHAZO_11",
      "RECHAZO_12",
      "RECHAZO_13",
      "RECHAZO_702",
      "RECHAZO_03",
      "RECHAZO_701",
      "SIN_PRESTAMOS_DISPONIBLES",
      "individuoNegativo",
      "datosIncorrectos",
      "RECHAZO_F_02",
      "RECHAZO_F_01",
      "mensaje-7"
    ];
    if (erroresRechazo.includes(errorCode)) {
      if (pxFace.method)
        window.fbq(pxFace.method, pxFace.event, pxFace.content);
    }
  }
};

export { Facebook };
